import React from 'react';
import { Box, Container } from '@mui/material';

/**
 * AuthLayout provides a consistent structure for authentication pages
 * with centered, responsive container and proper spacing
 */
const AuthLayout = ({ children, fullBleed = false }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: fullBleed ? 'transparent' : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        position: 'relative',
      }}
    >
      {fullBleed ? (
        <Box sx={{ flex: 1, minHeight: '100vh' }}>{children}</Box>
      ) : (
        <Container
          maxWidth="sm"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
            py: 4,
          }}
        >
          {children}
        </Container>
      )}
    </Box>
  );
};

export default AuthLayout;
